import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const rangeSettingState = atom({
  key: 'rangeSetting',
  default: {
    community: '',
    group: '',
    area: [],
    region: [],
    gender: '',
    age: '',
  },
});

export const dashBoardState = atom({
  key: 'dashboard',
  default: {
    count: 0,
  },
});

export const schoolListState = atom({
  key: 'schoolList',
  default: [
    [{ schoolSeq: 0, schoolGroupSeq: 0, schoolName: '', schoolGroupName: '' }],
  ],
});

export const selectSchoolInfoState = atom({
  key: 'selectSchoolInfo',
  default: {
    educationOfficeSeq: 0,
    schoolGroupSeq: 0,
    schoolSeq: 0,
    schoolName: '',
    schoolGroupName: '',
    schoolGrade: '1',
    schoolClass: '1',
    targetType: 'all',
    memberSeq: 0,
  },
});

export const educationOfficeInfoState = atom({
  key: 'educationOfficeInfo',
  default: {
    educationOfficeSeq: 0,
    educationOfficeName: '',
  },
});
